import { loadable } from 'utils';

export const Basic = loadable(() => import('./Basic'), {});
export const Simple = loadable(() => import('./Simple'), {});
